<mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>{{'carrier' | translate | capitalizeFirst}}</mat-label>
    <mat-select [value]="value" (selectionChange)="onSelectChange($event.value)" [disabled]="disabled">
        <mat-option *ngFor="let car of availableCarriers" [value]="getOptionValue(car)">
            {{ car.name }}
        </mat-option>
        <mat-option [value]="null" (selectionChange)="onSelectChange(null)">--</mat-option>
    </mat-select>
    <button mat-icon-button matSuffix type="button" aria-label="Clear selection" [disabled]="disabled"
        (click)="onSelectChange(null); $event.stopPropagation()">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</mat-form-field>